




























import { Vue, Component, Prop } from 'vue-property-decorator';

import Picture from '@/components/atoms/Picture/Picture.vue';
import CloseIcon from '@/components/icons/Close.vue';

import BusinessItem from './BusinessItem.vue';
import BusinessMenuItem from './BusinessMenuItem.vue';

import ManagerService from '@/api/ManagerService';
import BusinessService from '@/api/BusinessService';

import segmentIo from '@/utils/segment.io';
import { isRootUser } from '@/utils/auth';
import { insideProviderIframe } from '@/utils/providerIframe';
import { removeExternalOauthSession } from '@/router/router-utils';
import { FilledButton } from '@/components/molecules';
import { getSignUpUrl } from '@/views/Onboarding/helpers';
import logger from '@/utils/logger';

@Component({
  components: {
    Picture,
    BusinessItem,
    BusinessMenuItem,
    CloseIcon,
    FilledButton
  }
})
export default class BusinessMenuDropdown extends Vue {
  @Prop(Boolean) readonly viewOnly: boolean | undefined;
  @Prop() businesses!: any;
  @Prop() menuListOffset!: any;

  managerService: ManagerService = new ManagerService();
  businessService: BusinessService = new BusinessService();

  get tPrefix() {
    return 'menus.sidebar.businessMenuDrop';
  }

  get activeBusiness() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get showListOfBusiness() {
    return !isRootUser() && !insideProviderIframe();
  }

  get style() {
    if (!this.menuListOffset) return '';
    return {
      ...(this.menuListOffset.left !== undefined
        ? { left: `${this.menuListOffset.left}px` }
        : {}),
      ...(this.menuListOffset.top !== undefined
        ? { top: `${this.menuListOffset.top}px` }
        : {}),
      ...(this.menuListOffset.bottom !== undefined
        ? { bottom: `${this.menuListOffset.bottom}px` }
        : {})
    };
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'];
  }

  async changeBusiness(business: any) {
    if (this.viewOnly) {
      return false;
    }

    this.$showLoaderWithLocker();
    const { data, status } = await this.managerService.connect(business.id);

    if (status === 201) {
      segmentIo.track('Business Changed', {
        'Business Id': business.id,
        'Business Name': business.name,
        'Business Type': business.type
      });
      const { access_token } = data;
      segmentIo.reset();
      logger.reset();
      this.$store.dispatch('stripe/SET_STRIPE_DATA', '');
      this.businessService.setCredentials(access_token);
      window.location.href = '/home';
    }
  }

  gotoSignup() {
    if (this.viewOnly) {
      return false;
    }
    this.$emit('close');
    this.$store.dispatch('businessOnboarding/RESET_BUSINESS_ONBOARDING');
    removeExternalOauthSession();
    this.$router.push(`${getSignUpUrl()}?new-business=true`);
  }
}
